/* ==========================================================================
   Arts & Crafts Shop — Welcome offer (10% off your first order)

   WHAT IT DOES
     Shows a popup once per shopper. They enter an email, we:
       1. Post the address to the Mailchimp audience form (the same list
          the main site footer uses). Fire-and-forget, capped at 1.5 s.
       2. Submit the store's own /contact form natively (form_type=customer)
          so a Shopify customer is created with marketing consent and the
          tag popup-welcome10. Native, not fetch, because the store has
          Shopify's spam CAPTCHA on and only a real submit gets the token.
          Mailchimp's Shopify connection syncs the customer, tag included.
       3. Shopify sends them back to the same page with ?acw_done=1 and the
          popup reopens straight on the code, which is also pre-applied to
          the cart.

   WHAT YOU EDIT, AND WHERE
     Copy, code, timing ..... Theme customizer ("Welcome offer" section)
     The discount itself .... Shopify admin > Discounts > WELCOME10
                              (10% off, "customers who haven't purchased",
                               one use per customer)

   TRACKING
     Shopify.analytics.publish('acw_shown' | 'acw_signup' | 'acw_dismiss'
     | 'acw_copy') -> the "Welcome offer" custom pixel forwards these to
     GA4 (see shopify/pixels/). Signups are also countable without GA:
     Customers > filter by tag popup-welcome10. Redemptions: Analytics >
     Sales by discount > WELCOME10.

   TESTING
     ?acw=show   forces the popup open, ignoring the once-per-shopper rule
     ?acw=reset  forgets that this browser has seen or used it
   ========================================================================== */

(function () {
  'use strict';

  var S = window.ACW_SETTINGS || {};
  if (!S.enabled) return;

  var DONE_KEY    = 'acw_done_v1';      // signed up — never show again
  var SEEN_KEY    = 'acw_seen_v1';      // dismissed — show again after N days
  var SESSION_KEY = 'acw_session_v1';
  var FORCED      = false;

  /* ------------------------------------------------------------- helpers */

  function ls(fn) { try { return fn(window.localStorage); } catch (e) { return null; } }

  function sessionId() {
    try {
      var id = sessionStorage.getItem(SESSION_KEY);
      if (!id) {
        id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
        sessionStorage.setItem(SESSION_KEY, id);
      }
      return id;
    } catch (e) { return 'na'; }
  }

  function track(event, data) {
    if (!S.trackEvents) return;
    var payload = Object.assign({
      event: event,
      ts: new Date().toISOString(),
      session: sessionId(),
      page: S.template || '',
      path: window.location.pathname,
      code: S.code || ''
    }, data || {});
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('acw_' + event, payload);
      }
    } catch (e) {}
    if (S.trackUrl) {
      try {
        var body = JSON.stringify(payload);
        if (navigator.sendBeacon) {
          navigator.sendBeacon(S.trackUrl, new Blob([body], { type: 'text/plain' }));
        } else {
          fetch(S.trackUrl, { method: 'POST', body: body, mode: 'no-cors', keepalive: true });
        }
      } catch (e) {}
    }
    try { if (typeof S.onTrack === 'function') S.onTrack(payload); } catch (e) {}
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim());
  }

  /* --------------------------------------------------- should we show it? */

  (function readQuery() {
    var q = (window.location.search.match(/[?&]acw=([^&]+)/) || [])[1];
    if (!q) return;
    if (q === 'reset') ls(function (st) { st.removeItem(DONE_KEY); st.removeItem(SEEN_KEY); });
    if (q === 'show')  FORCED = true;
  })();

  function shouldShow() {
    if (FORCED) return true;
    if (S.loggedIn) return false;                                   // existing account: not a first order
    if ((S.excludeTemplates || []).indexOf(S.template) !== -1) return false;
    if (S.scope === 'home' && S.template !== 'index') return false;
    if (ls(function (st) { return st.getItem(DONE_KEY); })) return false;
    var seen = ls(function (st) { return st.getItem(SEEN_KEY); });
    if (seen) {
      var days = Number(S.reshowAfterDays || 30);
      if (days <= 0) return false;
      if (Date.now() - Number(seen) < days * 864e5) return false;
    }
    return true;
  }

  /* --------------------------------------------------------- subscribing */

  // 1. Shopify customer (marketing consent + tag) goes through a REAL form
  //    submit to /contact, the same thing the theme's footer newsletter
  //    form does. It has to be a native submit, not fetch: the store has
  //    Shopify's spam CAPTCHA turned on, and Shopify's own script attaches
  //    the token to the form on the submit event. Shopify then sends the
  //    shopper back to return_to, where we show the code.
  var PENDING_KEY = 'acw_pending_v1';

  function returnUrl() {
    var q = window.location.search.replace(/[?&]acw(_done)?=[^&]*/g, '').replace(/^&/, '?');
    return window.location.pathname + (q ? q + '&' : '?') + 'acw_done=1';
  }

  function cameBackFromSignup() {
    if (!/[?&]acw_done=1/.test(window.location.search)) return false;
    var pending = ls(function (st) { return st.getItem(PENDING_KEY); });
    // Tidy the address bar either way.
    try {
      var clean = window.location.pathname + window.location.search.replace(/[?&]acw_done=1/, '').replace(/^&/, '?') + window.location.hash;
      window.history.replaceState(null, '', clean);
    } catch (e) {}
    if (!pending) return false;
    ls(function (st) { st.removeItem(PENDING_KEY); st.setItem(DONE_KEY, String(Date.now())); st.removeItem(SEEN_KEY); });
    return true;
  }

  // 2. Mailchimp audience form (JSONP, like the embedded form on arts-crafts.ca).
  function subscribeMailchimp(email) {
    return new Promise(function (resolve) {
      if (!S.mailchimpAction) return resolve({ skipped: true });
      var cb = 'acwMc' + Date.now().toString(36);
      var done = false;
      var finish = function (res) { if (!done) { done = true; resolve(res || {}); } };
      window[cb] = function (res) {
        finish(res);
        try { delete window[cb]; } catch (e) { window[cb] = undefined; }
      };
      var url = S.mailchimpAction.replace('/subscribe/post?', '/subscribe/post-json?')
        + '&c=' + cb
        + '&EMAIL=' + encodeURIComponent(email)
        + (S.mailchimpTagIds ? '&tags=' + encodeURIComponent(S.mailchimpTagIds) : '')
        + '&' + encodeURIComponent(S.mailchimpHoneypot || 'b_x') + '=';
      var s = document.createElement('script');
      s.src = url;
      s.onerror = function () { finish({ result: 'error', msg: 'network' }); };
      document.head.appendChild(s);
      setTimeout(function () { finish({ result: 'timeout' }); }, 8000);
    });
  }

  /* --------------------------------------------------------------- modal */

  var overlay, modal, lastFocus;

  function build() {
    overlay = el('div', 'acw-overlay');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'acw-title');

    modal = el('div', 'acw-modal');
    modal.appendChild(el('div', 'acw-rule'));

    var x = el('button', 'acw-x', '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', function () { dismiss('x'); });
    modal.appendChild(x);

    var body = el('div', 'acw-body');
    body.innerHTML =
      '<p class="acw-eyebrow">' + esc(S.eyebrow) + '</p>' +
      '<h2 class="acw-title" id="acw-title">' + esc(S.heading).replace(/\{\{\s*percent\s*\}\}/g, '<em>' + esc(S.percent) + '%</em>') + '</h2>' +
      '<p class="acw-text">' + esc(S.body) + '</p>' +
      '<form class="acw-form" method="post" action="/contact#acw" accept-charset="UTF-8" novalidate>' +
        '<input type="hidden" name="form_type" value="customer">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="' + esc(S.customerTag || 'popup-welcome10') + '">' +
        '<input type="hidden" name="return_to" value="' + esc(returnUrl()) + '">' +
        '<div class="acw-field"><label class="visually-hidden" for="acw-email">Email</label>' +
        '<input class="acw-input" id="acw-email" type="email" name="contact[email]" autocomplete="email" inputmode="email" placeholder="' + esc(S.placeholder) + '" required></div>' +
        '<p class="acw-error" hidden></p>' +
        '<button class="acw-btn" type="submit">' + esc(S.button) + '</button>' +
      '</form>' +
      '<button class="acw-skip" type="button">' + esc(S.skip) + '</button>' +
      (S.footnote ? '<p class="acw-foot">' + esc(S.footnote) + '</p>' : '');
    modal.appendChild(body);
    overlay.appendChild(modal);

    body.querySelector('.acw-skip').addEventListener('click', function () { dismiss('skip'); });
    body.querySelector('.acw-form').addEventListener('submit', onSubmit);

    overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss('backdrop'); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(overlay);
  }

  function onKey(e) {
    if (e.key === 'Escape') { dismiss('esc'); return; }
    if (e.key !== 'Tab' || !overlay) return;
    var f = overlay.querySelectorAll('button, input, a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (overlay) return;
    // Give way to the EU / UK notice if it is on screen; try again shortly.
    if (document.querySelector('.aceu-overlay.is-open')) { setTimeout(open, 1500); return; }
    lastFocus = document.activeElement;
    build();
    document.documentElement.classList.add('acw-locked');
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      var inp = overlay.querySelector('.acw-input');
      if (inp && window.matchMedia('(min-width: 601px)').matches) inp.focus();
    });
    track('shown', { how: FORCED ? 'forced' : (openedBy || 'timer') });
  }

  function close() {
    if (!overlay) return;
    document.removeEventListener('keydown', onKey);
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('acw-locked');
    var o = overlay; overlay = null; modal = null;
    setTimeout(function () { if (o.parentNode) o.parentNode.removeChild(o); }, 260);
    try { if (lastFocus && lastFocus.focus) lastFocus.focus(); } catch (e) {}
  }

  function dismiss(how) {
    ls(function (st) { st.setItem(SEEN_KEY, String(Date.now())); });
    track('dismiss', { how: how });
    close();
  }

  function onSubmit(e) {
    var form = e.currentTarget;
    // Second pass: we already did our part, let the native submit (and
    // Shopify's CAPTCHA script) carry on.
    if (form.dataset.acwReady === '1') return;
    e.preventDefault();

    var input = form.querySelector('.acw-input');
    var err = form.querySelector('.acw-error');
    var btn = form.querySelector('.acw-btn');
    var email = (input.value || '').trim().toLowerCase();

    form.classList.remove('has-error'); err.hidden = true;
    if (!validEmail(email)) {
      form.classList.add('has-error');
      err.textContent = S.errorEmail || 'Please enter a valid email address.';
      err.hidden = false;
      input.focus();
      return;
    }
    input.value = email;

    btn.disabled = true; btn.textContent = S.buttonBusy || 'One moment…';
    ls(function (st) { st.setItem(PENDING_KEY, String(Date.now())); });
    track('signup', { how: openedBy || 'timer' });

    // Mailchimp first (fire-and-forget, capped so the submit never waits long),
    // then hand the form to the browser.
    var handOff = function () {
      if (form.dataset.acwReady === '1') return;
      form.dataset.acwReady = '1';
      if (S.preview) { showSuccess(); return; }          // preview page never leaves
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    };
    Promise.race([subscribeMailchimp(email), new Promise(function (r) { setTimeout(r, 1500); })])
      .then(function (mc) { track('mailchimp', { mc: (mc && mc.result) || 'timeout' }); })
      .then(handOff, handOff);
  }

  function showSuccess() {
    ls(function (st) { st.setItem(DONE_KEY, String(Date.now())); st.removeItem(SEEN_KEY); st.removeItem(PENDING_KEY); });
    var body = modal.querySelector('.acw-body');
    body.innerHTML =
      '<p class="acw-eyebrow">' + esc(S.successEyebrow) + '</p>' +
      '<h2 class="acw-title" id="acw-title">' + esc(S.successHeading) + '</h2>' +
      '<p class="acw-text">' + esc(S.successBody) + '</p>' +
      '<div class="acw-code"><span class="acw-code__value">' + esc(S.code) + '</span>' +
      '<button class="acw-copy" type="button">' + esc(S.copy || 'Copy') + '</button></div>' +
      '<button class="acw-btn" type="button">' + esc(S.successButton) + '</button>' +
      (S.successFootnote ? '<p class="acw-foot">' + esc(S.successFootnote) + '</p>' : '');
    var copy = body.querySelector('.acw-copy');
    copy.addEventListener('click', function () {
      var done = function () { copy.textContent = S.copied || 'Copied'; copy.classList.add('is-done'); track('copy'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(S.code).then(done, done);
      else done();
    });
    body.querySelector('.acw-btn').addEventListener('click', function () {
      track('continue');
      close();
      if (S.successUrl) window.location.href = S.successUrl;
    });
    // Pre-apply the code to the cart so it is already there at checkout.
    try { fetch('/discount/' + encodeURIComponent(S.code), { credentials: 'same-origin' }); } catch (e) {}
    body.querySelector('.acw-btn').focus();
  }

  /* ------------------------------------------------------------ triggers */

  var openedBy = null;

  function arm() {
    var fired = false;
    function go(how) { if (fired) return; fired = true; openedBy = how; open(); }

    if (FORCED) { go('forced'); return; }

    var delay = Number(S.delayMs);
    if (delay >= 0) setTimeout(function () { go('timer'); }, delay);

    var pct = Number(S.scrollPercent);
    if (pct > 0) {
      var onScroll = function () {
        var h = document.documentElement;
        var max = h.scrollHeight - h.clientHeight;
        if (max > 0 && (h.scrollTop / max) * 100 >= pct) {
          window.removeEventListener('scroll', onScroll);
          go('scroll');
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (S.exitIntent && window.matchMedia('(min-width: 1024px)').matches) {
      document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) go('exit'); });
    }
  }

  function openSuccess() {
    if (overlay) return;
    lastFocus = document.activeElement;
    build();
    document.documentElement.classList.add('acw-locked');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    track('signup_confirmed');
    showSuccess();
  }

  function boot() {
    if (cameBackFromSignup()) { openSuccess(); return; }
    if (shouldShow()) arm();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.ACW = { open: function () { FORCED = true; open(); }, reset: function () {
    ls(function (st) { st.removeItem(DONE_KEY); st.removeItem(SEEN_KEY); });
  } };
})();
